import axios from 'axios';

const isEventSubscribePage = () => {
    let isEventSubscribePage;
    const formPage = document.querySelector('#event-subscribe');

    if(formPage){
        // console.log('is Event Subscribe page!');
        isEventSubscribePage = true;
        lockScroll();
    } else {
        // console.log('is NOT Event Subscribe page!');
        isEventSubscribePage = false;
    }

    return isEventSubscribePage;
}

const lockScroll = () => {
    // console.log('lockScroll');
    let overlay = document.querySelector('#event-overlay');
    let page = document.querySelector('body.single-events');
    if(overlay.classList.contains('active')){
        page.classList.add('overlay-is-active');
        // console.log('page scroll is locked');
    }
}
const unlockScroll = () => {
    let page = document.querySelector('body.single-events');
    page.classList.remove('overlay-is-active');
    // console.log('page scroll is UNlocked');
}

const bakeSubscribeCookie = () => {
    let date = new Date();
    let expires;

    date = new Date();
    date.setTime(date.getTime()+(2*24*60*60*1000));
    expires = "; expires="+date.toUTCString();

    document.cookie = "NMAJHeventSubscribed=true" + expires+"; path=/";
    // console.log("Setting Cookies : " + "NMAJHeventSubscribed=true" );
}

const revealEvent = () => {
    let overlay = document.querySelector('#event-overlay');
    let event = document.querySelector('#event-subscribe');
    overlay.classList.remove('active');
    event.classList.remove('disabled');
    unlockScroll();
}

// get all forms
const eventSubscribeForms = Array.from(
    document.querySelectorAll('.subscribe__form')
);

let singleEventPage = isEventSubscribePage();

const loaderSvg = `<svg class="loader" version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve"><path d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"><animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform></path></svg>`;

let activeFormElement;
let activepageSlug;

var formObserverCallback = function(mutationsList, observer) {
    for(var mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // Loop through added nodes
            mutation.addedNodes.forEach(function(node) {
                // Check if the added node is a <p> tag with the class 'ctct-success'
                if (node.tagName === 'P' && node.classList.contains('ctct-success')) {
                    // console.log('Success message added', node);
                    activeFormElement.classList.remove('subscribe__form--processing');
                    activeFormElement.classList.add('subscribe__form--success');
                    fbq('trackCustom', 'EventLeadSignup', {event: activepageSlug});
                    bakeSubscribeCookie();
                    setTimeout(revealEvent,1000);
                }
            });
        }
    }
};

if ((singleEventPage == true) && eventSubscribeForms.length) {

    const items = Array.from(eventSubscribeForms);
    for (let x = 0; x < items.length; x++) {
        // get this item's id
        const itemId = items[x].getAttribute('id');
        // get this form by id
        const currentForm = document.getElementById(itemId);
        // get page slug
        const pageSlug = currentForm.dataset.pageSlug;

        // CONSTANT CONTACT FORM
        // prepopulate Constant Contact form custom field
        const overlayEventCustomField = currentForm.querySelector('input[placeholder="Overlay Event Name"]');
        if(overlayEventCustomField){
            overlayEventCustomField.value = pageSlug;
        }
        // check for the success message html element
        const overlaySuccessElement = currentForm.querySelector('p.ctct-success');
        if(overlaySuccessElement){
            currentForm.classList.add('subscribe__form--success');
            fbq('trackCustom', 'EventLeadSignup', {event: pageSlug});
            bakeSubscribeCookie();
            setTimeout(revealEvent,1000);
        }
        // Constant Contact form submit
        const ccFormButton = currentForm.querySelector('input[type="submit"]');
        if(ccFormButton){
            // style as button
            ccFormButton.classList.add('box-cta','box-cta--large','box-cta--red','box-cta-filled');
            // add loader
            ccFormButton.parentElement.insertAdjacentHTML('beforeend',loaderSvg);  
            // add action
            ccFormButton.addEventListener('click', event => {
                const thisFormEmailField = currentForm.querySelector('input[type="email"]');
                const thisFormEmailFieldContainer = thisFormEmailField.parentElement;
                if( validateEmail(thisFormEmailField.value) ){
                    // valid email, remove any errors
                    const errorMessage = thisFormEmailFieldContainer.querySelector('.ctct-form-error');
                    if(errorMessage){
                        errorMessage.remove();
                    }    
                    // set the form to processing
                    currentForm.classList.add('subscribe__form--processing');
                    // observe mutations to 
                    activeFormElement = currentForm;
                    activepageSlug = pageSlug;                    
                    var currentFormWrapper = currentForm.querySelector('.ctct-form-wrapper');
                    if (currentFormWrapper) {
                    var config = { childList: true, subtree: true };
                        var observer = new MutationObserver(formObserverCallback);                        
                        observer.observe(currentFormWrapper, config);
                        // console.log('Observing form...');
                    } 
                } else {
                    // invalid email, add error message
                    const errorMessage = document.createElement("div");
                    errorMessage.classList.add('ctct-form-error');
                    errorMessage.innerHTML = `Please enter a valid email.`;
                    thisFormEmailFieldContainer.appendChild(errorMessage);                
                }
            });           
        }
        // END CONSTANT CONTACT FORM




        /*
        // OLD SUBMIT METHOD, USING THE CONSTANT CONTACT V2 API

        let isLocal;
        let domain = document.location.origin;
        if(domain.includes('local')){
            console.log('is local');
            isLocal = true;
        } else {
            console.log('is live');
            isLocal = false;
        }

        // get list id
        const currentFormListId = currentForm.dataset.listId;
        // get this form errors element
        const thisFormErrors = document.querySelector('#'+itemId+' .subscribe__form-fields-error');

        // if(isLocal == true){
        //     let overlay = document.querySelector('#event-overlay');
        //     overlay.classList.add('success');
        //     let subscribedTy = document.querySelector('#subscribe__feedback-ty');
        //     let customSuccess = subscribedTy.dataset.success;
        //     subscribedTy.innerHTML = `Local Testing<br><br>${customSuccess}`;
        //     bakeSubscribeCookie();
        //     setTimeout(revealEvent,1000);
        // } else {
            
            currentForm.addEventListener('submit', event => {
                let header = document.querySelector('.subscribe__form-heading');            
                currentForm.classList.add('subscribe__form--processing');
                event.preventDefault();
                // build request url
                let requestUrl = siteUrl+'/constant-contact-api/';
                // form values
                const thisFormFirstNameField = document.querySelector('#'+itemId+' .subscribe__form-first-name');
                const thisFormLastNameField = document.querySelector('#'+itemId+' .subscribe__form-last-name');
                const thisFormEmailField = document.querySelector('#'+itemId+' .subscribe__form-email');
                // email
                let validEmail = validateEmail(thisFormEmailField.value);
                const subscribeFeedbackSuccessMessage = document.getElementById('subscribe__feedback-success-message');
                const subscribeFeedbackErrorMessage = document.getElementById('subscribe__feedback-error-message');
    
                if(validEmail){
                    const urlParams = new URLSearchParams(window.location.search);
                    const pageSlug = currentForm.dataset.pageSlug;
                    console.log(`submitting Single Event Subscribe form for the page: ${pageSlug}`);
                    thisFormErrors.innerHTML = '';
                    requestUrl += '?email='+thisFormEmailField.value+( currentFormListId !== '' ? '&list='+currentFormListId : '' );
                    requestUrl += thisFormFirstNameField.value !== '' ? '&first_name='+thisFormFirstNameField.value : '';
                    requestUrl += thisFormLastNameField.value !== '' ? '&last_name='+thisFormLastNameField.value : '';
                    requestUrl += urlParams.get('utm_source') != '' ? `&utm_source=${urlParams.get('utm_source')}` : `` ;
                    requestUrl += urlParams.get('utm_content') != '' ? `&utm_content=${urlParams.get('utm_content')}` : `` ;
                    console.log(requestUrl);
                    axios({
                        method:'get',
                        url: requestUrl
                    })
                    .then(function (response) {
                        console.log('success');
                        currentForm.classList.remove('subscribe__form--processing');
                        currentForm.classList.add('subscribe__form--success');
                        header.classList.add('hide');
                        if( subscribeFeedbackSuccessMessage && response ){
                            let overlay = document.querySelector('#event-overlay');
                            overlay.classList.add('success');
                            let subscribedTy = document.querySelector('#subscribe__feedback-ty');
                            let customSuccess = subscribedTy.dataset.success;
                            subscribedTy.innerHTML = `Thank you for subscribing.<br><br>${customSuccess}`;
                            fbq('trackCustom', 'EventLeadSignup', {event: pageSlug});
                            bakeSubscribeCookie();
                            setTimeout(revealEvent,1000);
                        }
                    })
                    .catch(function (error) {
                        console.log('error');
                        currentForm.classList.remove('subscribe__form--processing');
                        currentForm.classList.add('subscribe__form--error');
                        console.log(JSON.stringify(error));
                        if( subscribeFeedbackErrorMessage){
                            console.log(error);
                            //subscribeFeedbackErrorMessage.innerHTML = error.data.messages;
                        }
                    });
                } else {
                    currentForm.classList.remove('subscribe__form--processing');
                    thisFormErrors.innerHTML = 'Please enter a valid email address.';
                }
            });
            
        // }
        */


        
    }
}

const validateEmail = email => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

export {isEventSubscribePage};